import axios from 'axios';
import { setCameraData } from 'Redux/DashboardVariables';
import { setSearchEndDate } from 'Redux/DashboardVariables';
import { setSearchStartDate } from 'Redux/DashboardVariables';
import { setLocationsData } from 'Redux/DashboardVariables';
import { setWholeData } from 'Redux/DashboardVariables';
import store from 'storage';
import { handleDateFormat } from 'HelperFiles/DateHelper';
import { wholeDataGenerator } from 'HelperFiles/DataGenerator';
import { getAllIncidents } from 'HelperFiles/DashboardHelper';
import { generateAnalyticSummaryPageData } from 'HelperFiles/DataGenerator';
import { setAnalyticSummaryPageData } from 'Redux/DashboardVariables';

const FETCH_RUNTIME_EVENTS = 'FETCH_RUNTIME_EVENTS';
const SET_RUNTIME_EVENTS = 'SET_RUNTIME_EVENTS';
const initialState = [];
const initialAction = {
  type: '',
  payload: []
};

// actions
export const callRuntimeEvents = (data, successCallback = () => { }, failureCallback = () => { }) => ({
  type: FETCH_RUNTIME_EVENTS,
  payload: {
    data,
    successCallback,
    failureCallback
  }
});

// Middleware
export const callRuntimeEventsMidlleware =
  ({ dispatch, getState }) =>
    (next) =>
      (action) => {
        next(action);
        switch (action.type) {
          case FETCH_RUNTIME_EVENTS:
            dispatch(setRuntimeEventsLoader(true));
            const companyDetails = getState().companyDetails;
            const baseURL =
              process.env.REACT_APP_DORI_APP_SERVER ||
              getState().REACT_APP_DORI_APP_SERVER ||
              store.get("REACT_APP_DORI_APP_SERVER");
            const authToken = store.get("authToken");

            const {
              data: { resetSearchDate },
              successCallback,
              failureCallback
            } = action.payload;
            if (companyDetails && companyDetails.length) {
              const companyId = companyDetails[0].id;
              axios
                .request({
                  url: encodeURI(baseURL + `:8989/locations?id=${companyId}`),
                  method: "GET",
                  responseType: "json",
                  headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: authToken,
                  },
                })
                .then((res) => {
                  if (res.data.status.state === 'SUCCESS') {
                    const locationList = res.data.locations;
                    dispatch(setLocationsData(locationList));
                    var locationArrayData = locationList.map((location) => location.id);
                    if (locationArrayData && locationArrayData.length !== 0) {
                      Promise.all(
                        locationArrayData.map(async locationId => {
                          try {
                            const res = await axios
                              .request({
                                url: encodeURI(baseURL + `:8989/stream?id=${locationId}`),
                                method: "GET",
                                responseType: "json",
                                headers: {
                                  Accept: "application/json",
                                  "Content-Type": "application/json",
                                  Authorization: authToken,
                                },
                              });
                            return res.data;
                          } catch (e) {
                            console.log(e);
                            return e;
                          }
                        }
                        )
                      ).then((arrayOfArrays) => {
                        // console.log('promise settled: ', arrayOfArrays);
                        let cameraList = arrayOfArrays.flatMap((item) => item.cameras);
                        dispatch(setCameraData(cameraList));

                        let tempSKUList = [];
                        cameraList.forEach(camera => {
                          const tempConfig = JSON.parse(JSON.parse(camera.cameraConfig));
                          if (tempConfig.inventoryList) {
                            tempConfig.inventoryList.forEach(inventory => tempSKUList.push(inventory.productId));
                          }
                        });

                        let startTimeValue = resetSearchDate
                          ? new Date(new Date().getTime() - 3600 * 1000).getTime()
                          : new Date(getState().searchStartDate).getTime();
                        let endTimeValue =
                          resetSearchDate
                            ? new Date().getTime()
                            : new Date(getState().searchEndDate).getTime();
                        let startTimeStr = handleDateFormat(startTimeValue);
                        let endTimeStr = handleDateFormat(endTimeValue);
                        let incidentsApiData = {
                          locations: locationArrayData,
                          cameras: [],
                          startTime: startTimeValue,
                          endTime: endTimeValue,
                          duration: endTimeValue - startTimeValue,
                          incidentTypes: getState().allIncidents.apiCallAllEvents,
                          limit: 0,
                          offset: 0,
                          startTimeStr: startTimeStr,
                          endTimeStr: endTimeStr,
                          eventValidFlag: "ALL"
                        };
                        if (resetSearchDate) {
                          dispatch(setSearchStartDate(new Date(startTimeValue)));
                          dispatch(setSearchEndDate(new Date(endTimeValue)));
                        }
                        // console.log('camera list: ', cameraList, arrayOfArrays);

                        axios
                          .request({
                            url: encodeURI(baseURL + ':8989/get_events'),
                            method: "POST",
                            responseType: "json",
                            data: incidentsApiData,
                            headers: {
                              Accept: "application/json",
                              "Content-Type": "application/json",
                              Authorization: authToken,
                            },
                          })
                          .then((res) => {
                            const wholeData = wholeDataGenerator(res.data.incidents);
                            const analyticSummaryPageData = generateAnalyticSummaryPageData({
                              wholeData,
                              locationSelected: getState().locationSelected,
                              cameraSelected: getState().cameraSelected,
                              cameraData: cameraList,
                              locationsData: locationList,
                              searchStartDate: getState().searchStartDate,
                              searchEndDate: getState().searchEndDate,
                              allIncidents: getState().allIncidents,
                              selectedIncidents: getState().selectedIncidents,
                              applicationConfig: getState().applicationConfig
                            });

                            dispatch(setWholeData(wholeData));
                            dispatch(setAnalyticSummaryPageData(analyticSummaryPageData));
                            dispatch(setRuntimeEventsLoader(false));
                          })
                          .catch((err) => {
                            console.log(
                              "Failed to load event data: ",
                              err
                            );
                          });

                      });
                    } else {
                      dispatch(setRuntimeEventsLoader(false));
                    }

                  } else {
                    console.log('unable to fetch locations data. 1');
                    dispatch(setRuntimeEventsLoader(false));
                  }
                })
                .catch(e => {
                  console.log('unable to fetch locations data. 2');
                  dispatch(setRuntimeEventsLoader(false));
                })
            }

            break;

          default:
          // nothing to be done
        }
      };

// Api check variables
export const setRuntimeEventsLoader = (data) =>
  ({ type: 'RUNTIME_EVENTS_LOADER', payload: data });
export const runtimeEventsLoaderReducer = (state = false, action = { type: '', payload: false }) => {
  if (action.type === 'RUNTIME_EVENTS_LOADER') { return action.payload; } else { return state; }
};
export const getRuntimeEventsLoader = (state) => state.runtimeEventsLoader;


